import React, { useEffect, useRef, useState } from "react";
import { configuration } from "../../helpers/config";
import { Constants } from "../../helpers/constants";
import useIsMobile from "../../hooks/useIsMobile";
import axios from "axios";
import CompareItem from "./compareItem";
import LinkButton from "../button";
import { toggleForm } from "../../redux/ActionCreator";
import { formNames } from "../forms/Validation";
import { useDispatch, useSelector } from "react-redux";

//component to show compare section of different variants of a specific car.
const CompareBoard = ({
  data,
  modelcode,
  data2,
  bookMarkId,
  modelName,
  menuId,
  propulsion,
  sortedFeatures,
  sortedPerformance,
  local,
  pageUrl,
  staticModel,
  modelHeading,
  variantCmpfirstPrice,
  variantCmpsecondPrice,
  variantCmpthirdPrice,
  variantCmpfirstPriceText,
  variantCmpsecondPriceText,
  variantCmpthirdPriceText,
  additionalInformationOfModel,
}) => {
  const dispatch = useDispatch();
  const isMobile = useIsMobile();
  const [variants, setVariants] = useState({
    v1: data && data[0]?.variant_code,
    v2: data && data[1]?.variant_code,
    v3: data && data[2]?.variant_code,
  });

  // const [variants, setVariants] = useState()
  useEffect(()=>{
    setVariants({
      v1: data && data[0]?.variant_code,
      v2: data && data[1]?.variant_code,
      v3: data && data[2]?.variant_code,
    } 
    )
  },[data])
  const [tableData, setTableData] = useState({features: sortedFeatures,performance: sortedPerformance});
  const [isFixed, setIsFixed] = useState(false);
  const [showThird, setShowThird] = useState(false);
  const elementRef = useRef(null);
  const LobValue = useSelector((state) => state?.app?.LobValue);
  // function to handle scrolling behaviour so that model names can be aligned on top of screen if page is scrolled.
  useEffect(() => {
    const handleScroll = () => {
      const rect = elementRef.current.getBoundingClientRect();
      if (rect.top <= 0 && rect.bottom > 300) {
        setIsFixed(true);
      } else {
        setIsFixed(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    (async () => {
      try {
        // fetching data from model compare API. takes in 3 parameters that include variant code of upto 3 variants
        const res = await axios.get(
          `${configuration.APP_URL_PRODUCTS}model/compare/${modelcode}?v1=${variants.v1}&v2=${variants.v2}&v3=${variants.v3}`,
          configuration.HEADER_DEALER_LOCATOR_VAPT
        );
        // sorting performance data of the variants
        const sortedPerformance = [...res.data?.performance];
        // sorting features data of the variants
        const sortedFeatures = [...res.data?.features];
        // setting up data in the tableData state
        setTableData({
          features: sortedFeatures,
          performance: sortedPerformance,
        });
      } catch (e) {
        console.log(e.message);
      }
    })();
  }, [variants]);

  const FormName = LobValue
    ? LobValue == 1
      ? formNames.TEST_DRIVE
      : LobValue == 2
      ? formNames.TEST_DRIVE_2W
      : LobValue == 3
      ? formNames.TEST_DRIVE
      : "/404"
    : "/404";
    return (
    <div
      className="container mx-auto lg:pr-[30px] compare_drops"
      ref={elementRef}
      id={bookMarkId}
    >
      {isFixed && !local && (
        <div
          className={` container compareBoard__blank-placeholder--fixed  ${
            menuId && "ADD VARIANT" && isFixed ? "top-[20px]" : "top-[60px]"
          }  `}
        />
      )}
      {!local && (
        <h4 className="compare-section__heading" id="compareSectionHeading">
          {`${Constants.brandPage.BRANDPAGE_MODEL1} ${modelName} ${Constants.brandPage.BRANDPAGE_MODEL2}`}
        </h4>
      )}

      {configuration.VARIANT_COMPARISON_SECTION_IN_WEBSITE === "true" || configuration.VARIANT_COMPARISON_SECTION_IN_WEBSITE === true ? (
       <>
         {local && <h4 className="compare-section__heading" id="compareSectionHeading1">{staticModel}</h4>}
         {/* <p>Compare All {modelName} Models</p> */}
         <div className="grid grid-cols-2 md:grid-cols-4 gap-[10px] md:gap-[20px] lg:gap-[20px]" id="compareSection">
           <div className="hidden md:block" />
           {/* Determine the number of variants to show based on the available data */}
           {data?.filter(item=>item?.variant_code)
              ?.slice(0, data.length >= 3 && (!isMobile || showThird)? 3 : (isMobile || !showThird ? 2 : 3))
              .sort((a, b) => a.order_index - b.order_index) // Sort the data array based on order_index
              .map((item, idx) => (
                <CompareItem
                  local={local}
                  modelHeading={modelHeading}
                  onRemoveClick={() => setShowThird(false)}
                  menuId={menuId}
                  modelName={modelName}
                  fixed={isFixed}
                  modelCode={modelcode}
                  id={idx}
                  key={idx}
                  data={data}
                  propulsion={propulsion}
                  carName={item.variant_name}
                  item={item}
                  colors={item.colors}
                  imgW={310}
                  imgH={200}
                  data2={data2}
                  onVariantChange={(e) =>
                    setVariants({ ...variants, [`v${idx + 1}`]: e })
                  }
                  variantCmpfirstPrice={variantCmpfirstPrice}
                  variantCmpsecondPrice={variantCmpsecondPrice}
                  variantCmpthirdPrice={variantCmpthirdPrice}
                  variantCmpfirstPriceText={variantCmpfirstPriceText}
                  variantCmpsecondPriceText={variantCmpsecondPriceText}
                  variantCmpthirdPriceText={variantCmpthirdPriceText}
                  additionalInformationVariant={item?.additionalInformation}
                  additionalInformationOfModel={additionalInformationOfModel}
                />
              ))}
              {/*3rd variant visible on desktop if user clicks on add variant*/}
              {!showThird && data?.length < 3 && (
                <div className="compareItem_imageDetails !justify-start hidden md:block lg:block" id="compareItemBlock">
                  <div
                    className={`${
                      isFixed
                        ? " compareItem__selectbox--fixed z-[2] bg-inverted top-[100px] compareItem__selectbox"
                        : "w-full"
                    } ${
                      menuId && isFixed ? "top-[100px] w-full" : "top-[60px]"
                    }  text-sub-heading font-suzukiBold text-primary-blue items-start flex-row uppercase`}
                    id="compareItemSelectBox"
                  >
                    {!local && (
                      <div className="select-variant-btn flex justify-center shadow-[0px_4px_4px_rgba(0,0,0,0.15)] md:py-[12px] md:text-[22px] lg:text-[22px] md:min-h-[84px] lg:min-h-[84px] md:px-[10px] rounded-[4px]" id="addVariantSection">
                        {/*button for add variant to show 3rd variant on desktop*/}
                        <button
                    disabled={data?.filter(item=>item?.variant_code)?.length < 3}
                          onClick={() => setShowThird(true)}
                          className="flex items-center disabled:opacity-25"
                          id="addVariantButton"
                        >
                          <span className="inline-block mr-[15px] text-defaut-color">
                            {Constants.compare.ADD_VARIANT}
                          </span>
                          <img
                            src={`${configuration.IMG_STATIC_URL}assets/images/add-variant-icon.svg`}
                            alt="variant-icon"
                          />
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              )}
         </div>

         
      {/*"local" prop to show data that is not fetched from API and is present locally */}
      {!local && (
        <>
          <div className="border-b-gray border-b-[1px] md:border-none lg:border-none pb-[21px] md:pb-6 lg:pb-6 text-center md:text-left lg:text-left">
            <h2 className="mb-0">{Constants.brandPage.PERFORMANCE}</h2>
          </div>
          <div className="border-[#D9D8D9] border-0 md:border-y md:py-5 mb-[60px]">
            {tableData?.performance?.map((item, index) => (
            // {sortedPerformance && sortedPerformance?.map((item, index) => ( 
              <div
                className={`${
                  isMobile && data.length > 1 ? "grid" : "block"
                } md:grid lg:grid grid-cols-4 md:gap-[20px] lg:gap-[20px] gap-x-[10px] border-gray border-b-[1px] md:py-0 py-[20px] md:border-none`}
                key={index}
              >
                <p className="leading-[24px] md:col-span-1 col-span-4 text-center md:text-start md:border-0 mr-3 pb-[0px] mb-[6px] md:pb-0 md:mb-[15px] lg:pb-0 lg:mb-[15px]">
                  {item.featureName}
                </p>
                <p className="leading-[24px] font-suzukiBold col-span-2 md:col-span-1 text-center md:text-start mr-3 mb-0  md:mb-[15px]">
                  {item.v1}
                </p>
                <p className="leading-[24px] font-suzukiBold col-span-2 md:col-span-1 text-center md:text-start mr-3 mb-0 md:mb-[15px]">
                  {item.v2}
                </p>
                <p
                  className={`${
                    isMobile || showThird ? "hidden" : "block mb-[15px]"
                  } leading-[24px] font-suzukiBold `}
                >
                  {item.v3}
                </p>
              </div>
            ))}
          </div>
        </>
      )}

      {!local && (
        <>
          <div className="border-b-gray border-b-[1px] md:border-none lg:border-none pb-[21px] md:pb-6 lg:pb-6 text-center md:text-left lg:text-left">
            <h2 className="mb-0">{Constants.brandPage.KEY_FEATURES}</h2>
          </div>
          <div className="border-[#D9D8D9] border-0 md:border-y md:py-5 mb-[30px]">
            {tableData?.features?.map((item, index) => (
            // {sortedFeatures && sortedFeatures?.map((item, index) => ( 
              <div
                className={`${
                  isMobile && data.length > 1 ? "grid" : "block"
                } md:grid lg:grid grid-cols-4 md:gap-[20px] lg:gap-[20px] gap-x-[10px] border-gray border-b-[1px] md:py-0 py-[20px] md:border-none`}
                key={index}
              >
                <p className="leading-[24px] md:col-span-1 col-span-4 text-center md:text-start md:border-0 mr-3 pb-[0px] mb-[6px] md:pb-0 md:mb-[15px] lg:pb-0 lg:mb-[15px]">
                  {item.featureName}
                </p>
                <p className="leading-[24px] font-semibold col-span-2 md:col-span-1 text-center md:text-start mr-3 mb-0  md:mb-[15px]">
                  {item.v1}
                </p>
                <p className="leading-[24px] font-semibold col-span-2 md:col-span-1 text-center md:text-start mr-3 mb-0 md:mb-[15px]">
                  {item.v2}
                </p>
                <p
                  className={`${
                    isMobile || showThird ? "hidden" : "block mb-[15px]"
                  } leading-[24px] font-semibold `}
                >
                  {item.v3}
                </p>
              </div>
            ))}
          </div>
        </>
      )}
         </>
       ) : (
        <>
          {local && <h4 className="compare-section__heading" id="compareSectionHeading1">{staticModel}</h4>}

          {/* <p>Compare All {modelName} Models</p> */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-[10px] md:gap-[20px] lg:gap-[20px]" id="compareSection">
            <div className="hidden md:block" />

            {/* Show only 2 variants on mobile and 3 variants on desktop with a provision for an add variant button */}
            {data?.filter(item=>item?.variant_code)
              ?.slice(0, isMobile || !showThird ? 2 : 3)
              .sort((a, b) => a.order_index - b.order_index) // Sort the data array based on order_index
              .map((item, idx) => (
                <CompareItem
                  local={local}
                  modelHeading={modelHeading}
                  onRemoveClick={() => setShowThird(false)}
                  menuId={menuId}
                  modelName={modelName}
                  fixed={isFixed}
                  modelCode={modelcode}
                  id={idx}
                  key={idx}
                  data={data}
                  propulsion={propulsion}
                  carName={item.variant_name}
                  item={item}
                  colors={item.colors}
                  imgW={310}
                  imgH={200}
                  data2={data2}
                  onVariantChange={(e) =>
                    setVariants({ ...variants, [`v${idx + 1}`]: e })
                  }
                  variantCmpfirstPrice={variantCmpfirstPrice}
                  variantCmpsecondPrice={variantCmpsecondPrice}
                  variantCmpthirdPrice={variantCmpthirdPrice}
                  variantCmpfirstPriceText={variantCmpfirstPriceText}
                  variantCmpsecondPriceText={variantCmpsecondPriceText}
                  variantCmpthirdPriceText={variantCmpthirdPriceText}
                  additionalInformationVariant={item?.additionalInformation}
                  additionalInformationOfModel={additionalInformationOfModel}
                />
              ))}


        {/*3rd variant visible on desktop if user clicks on add variant*/}
        {!showThird && (
                <div className="compareItem_imageDetails !justify-start hidden md:block lg:block" id="compareItemBlock">
                  <div
                    className={`${
                      isFixed
                        ? " compareItem__selectbox--fixed z-[2] bg-inverted top-[100px] compareItem__selectbox"
                        : "w-full"
                    } ${
                      menuId && isFixed ? "top-[100px] w-full" : "top-[60px]"
                    }  text-sub-heading font-suzukiBold text-primary-blue items-start flex-row uppercase`}
                    id="compareItemSelectBox"
                  >
                    {!local && (
                      <div className="select-variant-btn flex justify-center shadow-[0px_4px_4px_rgba(0,0,0,0.15)] md:py-[12px] md:text-[22px] lg:text-[22px] md:min-h-[84px] lg:min-h-[84px] md:px-[10px] rounded-[4px]" id="addVariantSection">
                        {/*button for add variant to show 3rd variant on desktop*/}
                        <button
                    disabled={data?.filter(item=>item?.variant_code)?.length < 3}
                          onClick={() => setShowThird(true)}
                          className="flex items-center disabled:opacity-25"
                          id="addVariantButton"
                        >
                          <span className="inline-block mr-[15px] text-defaut-color">
                            {Constants.compare.ADD_VARIANT}
                          </span>
                          <img
                            src={`${configuration.IMG_STATIC_URL}assets/images/add-variant-icon.svg`}
                            alt="variant-icon"
                          />
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              )}
          </div>

           {/*"local" prop to show data that is not fetched from API and is present locally */}
      {!local && (
        <>
          <div className="border-b-gray border-b-[1px] md:border-none lg:border-none pb-[21px] md:pb-6 lg:pb-6 text-center md:text-left lg:text-left">
            <h2 className="mb-0">{Constants.brandPage.PERFORMANCE}</h2>
          </div>
          <div className="border-[#D9D8D9] border-0 md:border-y md:py-5 mb-[60px]">
            {tableData?.performance?.map((item, index) => (
            // {sortedPerformance && sortedPerformance?.map((item, index) => ( 
              <div
                className={`${
                  isMobile && data.length > 1 ? "grid" : "block"
                } md:grid lg:grid grid-cols-4 md:gap-[20px] lg:gap-[20px] gap-x-[10px] border-gray border-b-[1px] md:py-0 py-[20px] md:border-none`}
                key={index}
              >
                <p className="leading-[24px] md:col-span-1 col-span-4 text-center md:text-start md:border-0 mr-3 pb-[0px] mb-[6px] md:pb-0 md:mb-[15px] lg:pb-0 lg:mb-[15px]">
                  {item.featureName}
                </p>
                <p className="leading-[24px] font-suzukiBold col-span-2 md:col-span-1 text-center md:text-start mr-3 mb-0  md:mb-[15px]">
                  {item.v1}
                </p>
                <p className="leading-[24px] font-suzukiBold col-span-2 md:col-span-1 text-center md:text-start mr-3 mb-0 md:mb-[15px]">
                  {item.v2}
                </p>
                <p
                  className={`${
                    isMobile || !showThird ? "hidden" : "block mb-[15px]"
                  } leading-[24px] font-suzukiBold `}
                >
                  {item.v3}
                </p>
              </div>
            ))}
          </div>
        </>
      )}

      {!local && (
        <>
          <div className="border-b-gray border-b-[1px] md:border-none lg:border-none pb-[21px] md:pb-6 lg:pb-6 text-center md:text-left lg:text-left">
            <h2 className="mb-0">{Constants.brandPage.KEY_FEATURES}</h2>
          </div>
          <div className="border-[#D9D8D9] border-0 md:border-y md:py-5 mb-[30px]">
            {tableData?.features?.map((item, index) => (
            // {sortedFeatures && sortedFeatures?.map((item, index) => ( 
              <div
                className={`${
                  isMobile && data.length > 1 ? "grid" : "block"
                } md:grid lg:grid grid-cols-4 md:gap-[20px] lg:gap-[20px] gap-x-[10px] border-gray border-b-[1px] md:py-0 py-[20px] md:border-none`}
                key={index}
              >
                <p className="leading-[24px] md:col-span-1 col-span-4 text-center md:text-start md:border-0 mr-3 pb-[0px] mb-[6px] md:pb-0 md:mb-[15px] lg:pb-0 lg:mb-[15px]">
                  {item.featureName}
                </p>
                <p className="leading-[24px] font-semibold col-span-2 md:col-span-1 text-center md:text-start mr-3 mb-0  md:mb-[15px]">
                  {item.v1}
                </p>
                <p className="leading-[24px] font-semibold col-span-2 md:col-span-1 text-center md:text-start mr-3 mb-0 md:mb-[15px]">
                  {item.v2}
                </p>
                <p
                  className={`${
                    isMobile || !showThird ? "hidden" : "block mb-[15px]"
                  } leading-[24px] font-semibold `}
                >
                  {item.v3}
                </p>
              </div>
            ))}
          </div>
        </>
      )}
        </>
      )}


      {/*buttons to toggle forms */}

      {!local && (
        <div className="grid grid-cols-1 mt-10 md:grid-cols-4 gap-y-5 md:gap-x-2">
          <div className="hidden md:block" />
          <div className="compareItem__CTAs">
            <LinkButton
              Id="ModelFinanceCalculatorBtn"
              type={"button_dark_arrow"}
              buttontext={Constants.brandPage.FINANCE_CALCULATOR}
          //     href={`${configuration?.COUNTRY_CODE!="MEX"?
          //     LobValue === "1"
          //       ? "/calc-payment?model=" + pageUrl
          //       : LobValue === "2"
          //       ? "/calc-payment-2w?model=" + pageUrl
          //       : "/calc-payment-marine?model=" + pageUrl
          //   :
          //   // { pathname: '/emi-calculator', query: { modelname: modelName, modelcode: modelcode} }
          //   `/emi-calculator?modelname=${modelName}&modelcode=${modelcode}`
          // }`}
          href={
            configuration?.COUNTRY_CODE === "HUN"
              ? "https://konfigurator.suzuki.hu"
              : configuration?.COUNTRY_CODE === "MEX"
              ? `/emi-calculator?modelname=${modelName}&modelcode=${modelcode}`
              : LobValue === "1"
              ? `/calc-payment?model=${pageUrl}`
              : LobValue === "2"
              ? `/calc-payment-2w?model=${pageUrl}`
              : LobValue === "3"
              ? `/calc-payment-marine?model=${pageUrl}`
              : "#"
          }
              classname="button_dark_arrow group fullBorder__btn"
            />
          </div>
          <div className="compareItem__CTAs">
            <LinkButton
              Id="ModelTestDriveFormBtn"
              type={"button_dark_arrow_button"}
              buttontext={Constants.brandPage.BOOK_A_TEST_DRIVE}
              onClick={() => dispatch(toggleForm(FormName))}
              classname="button_dark_arrow fullBorder__btn"
            />
          </div>
        </div>
      )}
    </div>
  );
};
export default CompareBoard;
